/**
 * Returns a formatted chip label based on provided parameters, optionally including a prefix label.
 * @param {GetChipLabelParams} params - Parameters controlling how the chip label is composed.
 * @param {string} [params.label] - Optional prefix label to display.
 * @param {boolean} [params.showLabel] - Whether to include the prefix label in the output.
 * @param {string | number} [params.valueLabel] - The value to display in the chip label.
 * @returns {string | undefined} The formatted chip label, or undefined if no value label is provided.
 */
export function getChipLabel({ label, showLabel, valueLabel }) {
    if (!valueLabel) {
        return;
    }
    if (showLabel && label) {
        return `${label}: ${valueLabel}`;
    }
    return `${valueLabel}`;
}
